
import { useAuth } from "@/store/auth"
import { useDialogs, type DialogNames } from "@/hooks/use-dialogs"
import { Avatar, AvatarFallback } from "@/components/ui/avatar"
import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

import Dialogs from "./dialogs"

export function StaffNav() {
  const dialogs = useDialogs<DialogNames<typeof Dialogs>>()
  const { user } = useAuth()

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="secondary" className="relative size-9 rounded-full">
            <Avatar className="size-10">
              <AvatarFallback className="bg-primary/10 text-sm font-semibold text-primary">
                {`${user?.firstName.charAt(0)}${user?.lastName.charAt(0)}`.toUpperCase()}
              </AvatarFallback>
            </Avatar>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="w-56"
          align="end"
          forceMount
          onCloseAutoFocus={e => e.preventDefault()}
        >
          <DropdownMenuLabel className="font-normal">
            <div className="flex flex-col space-y-1">
              <p className="text-sm font-medium leading-none">
                {user?.fullName}
              </p>
              <p className="text-xs leading-none text-muted-foreground">
                {user?.email}
              </p>
            </div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuGroup>
            <DropdownMenuItem onClick={dialogs.toggle("ChangePasswordDialog")}>
              Change Password
            </DropdownMenuItem>
            {/* <ThemeDropdownMenuSub /> */}
          </DropdownMenuGroup>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={dialogs.toggle("SignOutConfirmation")}>
            Sign out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <Dialogs.SignOutConfirmation
        {...dialogs.getProps("SignOutConfirmation")}
      />
      <Dialogs.ChangePasswordDialog
        {...dialogs.getProps("ChangePasswordDialog")}
      />
    </>
  )
}

// const ThemeDropdownMenuSub = () => {
//   const { theme, setTheme } = useTheme()

//   const changeTheme = (t: typeof theme) => () => {
//     setTheme(t)
//   }

//   return (
//     <DropdownMenuSub>
//       <DropdownMenuSubTrigger>Theme</DropdownMenuSubTrigger>
//       <DropdownMenuPortal>
//         <DropdownMenuSubContent>
//           <DropdownMenuCheckboxItem
//             checked={theme === "light"}
//             onClick={changeTheme("light")}
//           >
//             <Sun name="sun" size="1rem" strokeWidth={1} />
//             <span className="ml-2">Light</span>
//           </DropdownMenuCheckboxItem>
//           <DropdownMenuCheckboxItem
//             checked={theme === "dark"}
//             onClick={changeTheme("dark")}
//           >
//             <Moon name="moon" size="1rem" strokeWidth={1} />
//             <span className="ml-2">Dark</span>
//           </DropdownMenuCheckboxItem>
//           <DropdownMenuCheckboxItem
//             checked={theme === "system"}
//             onClick={changeTheme("system")}
//           >
//             <Computer name="computer" size="1rem" strokeWidth={1} />
//             <span className="ml-2">System</span>
//           </DropdownMenuCheckboxItem>
//         </DropdownMenuSubContent>
//       </DropdownMenuPortal>
//     </DropdownMenuSub>
//   )
// }
